module.exports = __webpack_public_path__ + "static/media/errorText.b2b1d03f.png";